module.exports = __webpack_public_path__ + "static/media/birthday2023_star.8de8d96a.png";